/**
 * JSON-LD を dangerouslySetInnerHTML 用の値にする。`</script>` で閉じられないよう `<` は JSON のエスケープに置き換える
 * 子要素で渡すと React が `"` を `&quot;` に変換し JSON として読めなくなるため innerHTML で出力する（Next.js 公式の推奨: https://nextjs.org/docs/app/guides/json-ld）
 */
export const createJsonLdHtml = (data: unknown) => ({
  __html: JSON.stringify(data).replace(/</g, '\\u003c'),
});
